import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, watch } from 'vue';
import { type GProductLicense } from '@daocloud-proto/ghippo/v1alpha1/gproductlicense.pb';
import { useGlobalStore } from '@/stores';
import { useI18n } from 'vue-i18n';
import getLicensesOverQuota from '@/utils/getLicensesOverQuota';


export default /*#__PURE__*/_defineComponent({
  __name: 'LicenseExpire',
  setup(__props) {

const store = useGlobalStore();
const { t } = useI18n();

const isShowMessage = computed(
  () => store.license.expireSoonLicenses?.length || store.license.expiredLicenses?.length,
);

watch(() => store.locale, async () => {
  await getLicensesOverQuota();
});

const jointModules = (licenses: GProductLicense[]) => (licenses.map(({ module }) => module).join(t('common.comma')));

const content = computed(() => {
  const { expiredLicenses = [], expireSoonLicenses = [] } = store.license;
  const expiredLength = expiredLicenses.length;
  const expireSoonLength = expireSoonLicenses.length;
  const all = expiredLength + expireSoonLength;

  if (expiredLength === all) {
    return t('components.LicenseExpire.allExpired', {
      licenses: jointModules(expiredLicenses),
      count: all,
    });
  }
  if (expireSoonLength === all) {
    return t('components.LicenseExpire.allSoonExpire', {
      licenses: jointModules(expireSoonLicenses),
      count: all,
    });
  }

  return t('components.LicenseExpire.partExpired', {
    expiredLicenses: jointModules(expiredLicenses),
    expiredCount: expiredLength,
    expireSoon: jointModules(expireSoonLicenses),
    expireSoonCount: expireSoonLength,
  });
});

getLicensesOverQuota();


return (_ctx: any,_cache: any) => {
  const _component_dao_history_link = _resolveComponent("dao-history-link")!
  const _component_dao_message = _resolveComponent("dao-message")!

  return (_unref(isShowMessage))
    ? (_openBlock(), _createBlock(_component_dao_message, {
        key: 0,
        class: "ghippo-license-expire",
        type: "warning",
        "is-close-show": false
      }, {
        default: _withCtx(({ className }) => [
          _createElementVNode("span", {
            class: _normalizeClass(className)
          }, [
            _createTextVNode(_toDisplayString(_unref(content)) + " ", 1),
            _createVNode(_component_dao_history_link, {
              type: "action",
              href: _unref(store).getProductLink('ghippo','/settings/license/list')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('components.LicenseExpire.link')), 1)
              ]),
              _: 1
            }, 8, ["href"])
          ], 2)
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})